module.exports = __webpack_public_path__ + "ua.svg?223ace875e96cae59950f636f583b196";